export default {
  id: 30,
  title: 'Target #30 - Horizon',
  url: 'https://cssbattle.dev/play/30',
  colors: ['#F7EC7D', '#E38F66', '#AA445F', '#62306D'],
  solution:
    '<style>body{background:linear-gradient(#f7ec7d 50px,#e38f66 50px,#e38f66 100px,#aa445f 100px,#aa445f 200px,#62306d 200px,#62306d 300px)}</style>',
}
